import { useState } from "react";
import { C } from "../lib/colors";

// Password input with an eye-icon show/hide toggle built into the field.
// Drop-in replacement for the previous "Show / Hide" text button pattern.
export const PasswordInput = ({
  value,
  onChange,
  onKeyDown,
  placeholder = "Your password",
  autoComplete = "current-password",
  hasError = false,
  disabled = false,
}) => {
  const [visible, setVisible] = useState(false);
  const baseBorder = hasError ? C.red : C.border;

  return (
    <div style={{ position: "relative" }}>
      <input
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        disabled={disabled}
        style={{
          width: "100%",
          background: C.s2,
          border: `1.5px solid ${baseBorder}`,
          borderRadius: 10,
          padding: "12px 44px 12px 14px",
          color: C.text,
          fontSize: 14,
          fontFamily: "'Instrument Sans',sans-serif",
          transition: "border-color 0.2s",
          opacity: disabled ? 0.6 : 1,
        }}
        onFocus={(e) => { e.target.style.borderColor = hasError ? C.red : C.green; }}
        onBlur={(e) => { e.target.style.borderColor = hasError ? C.red : C.border; }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        tabIndex={-1}
        style={{
          position: "absolute",
          top: "50%",
          right: 10,
          transform: "translateY(-50%)",
          background: "transparent",
          border: "none",
          padding: 6,
          cursor: "pointer",
          color: C.muted,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = C.muted; }}
      >
        {visible ? (
          // Eye-off icon
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-10-7-10-7a18.45 18.45 0 0 1 5.06-5.94"/>
            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 7 10 7a18.5 18.5 0 0 1-2.16 3.19"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
            <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/>
          </svg>
        ) : (
          // Eye icon
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
        )}
      </button>
    </div>
  );
};
